var ajaxLoadMore = {
  list_wrap_class: '.ajax_list_wrap',
  nav_class: '.loadmore-nav',
  btn_class: '.loadmore-btn',

  init: function (callback) {
    var s = this;
    
    $(s.nav_class).find(s.btn_class).off('click').on('click', function (e) {
      var url = $(this).attr('href');
      // s.page ++;
      s.startLoad(url, callback);
      e.preventDefault();
    });
  },

  startLoad: function (link, callback) {
    var s = this;
    var wrap_el = $(s.list_wrap_class);
    var loader_nav = $(s.nav_class);
    var post_type = loader_nav.data('post_type');
    
    $('body').addClass('tt-ajax-loader');

    $.ajax({
      method: 'get',
      url: link,
      // data: { ptype:post_type, perpage:s.per_page, paged:page },
      dataType: "html"
    }).done(function (data) {
      // var $content = $($.parseHTML(data, document, true));
      var wrapper = document.createElement('div');
      wrapper.innerHTML = data;

      var new_wrap_el = wrapper.querySelector(s.list_wrap_class);
      wrap_el.append(new_wrap_el.innerHTML);

      var new_nav_el = wrapper.querySelector(s.nav_class);
      
      if (new_nav_el) {
        loader_nav.replaceWith(new_nav_el);
        s.init();
      } else {
        loader_nav.find(s.btn_class).remove();
        loader_nav.addClass('nomore');
      }
     
      $('body').removeClass('tt-ajax-loader');
      // skrollrObj.refresh(wrap_el);
      animElements.init(s.list_wrap_class);

      if (post_type == 'products') ajaxLoad.alink('.ajax_pdc', true, 'product');
      if (post_type == 'projects') ajaxLoad.alink('.ajax_pjc', true, 'project');
      if (post_type == 'news') ajaxLoad.alink('.ajax_news', true, 'news');
      if (post_type == 'designers') ajaxLoad.alink('.ajax_designer', true, 'designer');

      if(callback) callback();
    });
  }
}